import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import TextField from "react-md/lib/TextFields";
import List from "react-md/lib/Lists/List";
import ListItem from "react-md/lib/Lists/ListItem";
import { CustomerShape } from "../../../common/proptypes";
import ExportCsvButton from "../ExportCsvButton";

class SearchCustomer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchKeyword: ""
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentWillUnmount() {
    this.props.onClearSearchCustomerResult();
  }

  handleSearch(value) {
    const { onSearchCustomer, onClearSearchCustomerResult } = this.props;

    if (value) {
      onSearchCustomer(value);
    } else {
      onClearSearchCustomerResult();
    }

    this.setState(() => ({
      searchKeyword: value
    }));
  }

  render() {
    const { className, searchResult, isAdmin } = this.props;
    return (
      <div className={className}>
        {/* export button display on the right side */}
        <div className="md-cell md-cell--12" style={{ position: "relative" }}>
          <h5 className="md-headline">Search</h5>
          {isAdmin &&
            <ExportCsvButton
              style={{ position: "absolute", right: 0, bottom: 0 }}
            />}
        </div>
        <TextField
          id="searchCustomer"
          label="Search customer"
          lineDirection="center"
          placeholder="Type customer phone or email to search"
          className="md-cell md-cell--12 md-cell--bottom"
          value={this.state.searchKeyword}
          onChange={this.handleSearch}
        />
        {searchResult &&
          searchResult.length > 0 &&
          <List className="md-cell md-cell--12 md-paper md-paper--1">
            {searchResult.map(customer => (
              <Link
                key={customer.key}
                to={`/customer/${customer.key}`}
                style={{ textDecoration: "none" }}
              >
                <ListItem
                  primaryText={`${customer.firstName} ${customer.lastName}`}
                  secondaryText={`Phone: ${customer.phone} - Email: ${customer.email}`}
                />
              </Link>
            ))}
          </List>}
      </div>
    );
  }
}

SearchCustomer.propTypes = {
  onSearchCustomer: PropTypes.func.isRequired,
  onClearSearchCustomerResult: PropTypes.func.isRequired,
  className: PropTypes.string,
  searchResult: PropTypes.arrayOf(CustomerShape)
};

SearchCustomer.defaultProps = {
  className: null,
  searchResult: []
};

export default SearchCustomer;



// WEBPACK FOOTER //
// ./src/customer/components/SearchCustomer/SearchCustomer.jsx